import React, { useEffect, useState } from "react";
import { X, Info } from "lucide-react";
import "./RenameEsimModal.css";
import { useLanguage } from "../../i18n/LanguageContext";

export default function RenameEsimModal({
                                            open,
                                            onClose,
                                            simId,
                                            currentLabel,
                                            onRenamed, // optional callback to update parent state
                                        }) {
    const [value, setValue] = useState(currentLabel || "");
    const [saving, setSaving] = useState(false);
    const { t } = useLanguage();
    const MAX = 40;

    useEffect(() => {
        if (open) setValue(currentLabel || "");
    }, [open, currentLabel]);

    const handleSubmit = async () => {
        if (!value.trim() || value.trim() === currentLabel) return;

        try {
            setSaving(true);

            const resp = await fetch("https://api.artamobile.id/v1/esims/label", {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ SimId: simId, newLabel: value.trim() }),
            });
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);

            // ✅ Notify parent of success
            onRenamed?.(value.trim());
            onClose();
            alert(t("renameModal.success"));
        } catch (err) {
            console.error(err);
            alert(t("renameModal.failed"));
        } finally {
            setSaving(false);
        }
    };

    if (!open) return null;

    const remaining = MAX - value.length;

    return (
        <div className="rename-modal-backdrop" role="dialog" aria-modal="true">
            <div className="rename-modal">
                <button className="modal-close" aria-label={t("common.close")} onClick={onClose}>
                    <X size={20} />
                </button>

                <h3 className="modal-title">{t("renameModal.title")}</h3>

                <div className="modal-info">
                    <Info size={18} />
                    <span>{t("renameModal.info")}</span>
                </div>

                <label className="input-label" htmlFor="esim-name">
                    {t("renameModal.label")}
                </label>
                <input
                    id="esim-name"
                    className="modal-input"
                    placeholder={t("renameModal.label")}
                    maxLength={MAX}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    autoFocus
                />
                <div className="char-left">{t("renameModal.remaining", { n: remaining })}</div>

                <div className="modal-actions">
                    <button
                        className="primary"
                        disabled={saving || !value.trim() || value.trim() === currentLabel}
                        onClick={handleSubmit}
                    >
                        {saving ? t("renameModal.saving") : t("renameModal.submit")}
                    </button>
                </div>
            </div>
        </div>
    );
}
